module.exports = __webpack_public_path__ + "img/Arrow-up-deep-fjord-900.4407ae82.svg";